module.exports = function() {
  return new Worker(__webpack_public_path__ + "9e3ed89b9a801e0b24af.worker.js");
};